<div class="d-flex align-items-center">
    <div class="d-flex justiy-content-center" style="margin-right: 1.5rem">
        <label-extended-control [labelText]="labelText"></label-extended-control>
        <div *ngIf="showIcon" class="icon">
            <span [class]="iconClass"></span>
        </div>
    </div>
    <input [formControlName]="controlName" [id]="inputId" type="color" [class]="inputClass" [attr.placeholder]="placeholderText | translate" [readOnly]="readonly" [ngClass]="{ 'no-icon': !showIcon }" autocomplete="off" />
</div>
<field-error-display-control [displayError]="parentFormHelper.showFieldError(controlName)" [errorMsg]="parentFormHelper.getErrorMessageHtml(controlName)"> </field-error-display-control>
